import { render, staticRenderFns } from "./RecordDetail.vue?vue&type=template&id=995da1aa&scoped=true&"
import script from "./RecordDetail.vue?vue&type=script&lang=js&"
export * from "./RecordDetail.vue?vue&type=script&lang=js&"
import style0 from "../../less/order.less?vue&type=style&index=0&id=995da1aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995da1aa",
  null
  
)

export default component.exports